import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { Loader } from '@thd-olt-component-react/loader';
import './LoadingScreen.style.scss';

export const LoadingScreen = ({ message }) => {
  return (
    <div className="loading-screen-container">
      <div className="sui-flex sui-items-center sui-w-full sui-justify-center sui-flex-col sui-mt-80">
        <Loader active />
        <div className="sui-pt-5">
          <Typography weight="regular" variant="h2">
            {message}
          </Typography>
        </div>
      </div>
    </div>
  );
};

LoadingScreen.propTypes = {
  message: PropTypes.string,
};
LoadingScreen.defaultProps = {
  message: '',
};
